export default class Paging {
    constructor(public readonly pageNumber: number, public readonly pageSize: number) {}
}